import classNames from 'classnames';

type TickProps = {
  width?: number | string;
  height?: number | string;
  className?: string | Array<string>;
};

const Tick = ({ width = 8, height = 7, className }: TickProps) => (
  <svg
    focusable={false}
    className={classNames(className)}
    width={width}
    height={height}
    viewBox='0 0 8 7'
  >
    <path
      d='M1 4l2 2 3.995-4'
      fill='none'
      fillRule='evenodd'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default Tick;
